import React, { useMemo, useState } from 'react';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { SegmentContainer } from './mediaStyles';
import { Place } from '../../../models/Place';
import Grid from './Grid';
import { Media } from '../../../pages/innerPages/DELETEMEbookmarks';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';

type MediaProps = {
	place: Place;
};

const MediaGrid: React.FC<MediaProps> = ({ place }) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);

	const [listKey, setListKey] = useState('photos');
	const mediaImg: Media[] = useMemo(() => {
		const hasMediaValue = (value: unknown): value is string =>
			typeof value === 'string' && value.trim() !== '';

		const featuredImages: Media[] = place.trails
			.filter((trail) => hasMediaValue(trail.image))
			.map((trail) => ({
				src: trail.image,
				videoSrc: false,
				caption: trail.title,
			}));
		const pointImages = place.trails.flatMap((trail) =>
			trail.points
				.filter(
					(point) =>
						hasMediaValue(point.poi_image) &&
						!hasMediaValue(point.poi_video),
				)
				.map(
					(point) =>
						({
							src: point.poi_image,
							videoSrc: false,
							caption: point.title,
						} as Media),
				),
		);

		return featuredImages.concat(pointImages);
	}, [place]);
	const mediaVideo: Media[] = useMemo(() => {
		const hasMediaValue = (value: unknown): value is string =>
			typeof value === 'string' && value.trim() !== '';

		return place.trails.flatMap((trail) =>
			trail.points
				.filter((point) => hasMediaValue(point.poi_video))
				.map(
					(point) =>
						({
							src: hasMediaValue(point.poi_image)
								? point.poi_image
								: trail.image,
							videoSrc: point.poi_video,
							caption: point.title,
						} as Media),
				),
		);
	}, [place]);
	const offlineMediaPreview = useMemo(() => mediaImg.slice(0, 6), [mediaImg]);

	return (
		<div>
			{network_status &&
			(mediaImg.length > 0 || mediaVideo.length > 0) ? (
				<>
					<SegmentContainer>
						<IonSegment
							color="secondary"
							value={listKey}
							onIonChange={(e) => {
								if (e.detail.value === undefined) return;
								setListKey(e.detail.value);
								if (e.detail.value === 'photos') {
									//setList(mediaImg);
								} else {
									//setList(mediaVideo);
								}
							}}>
							<IonSegmentButton value="photos">
								<IonLabel>Photos</IonLabel>
							</IonSegmentButton>
							<IonSegmentButton value="videos">
								<IonLabel>Videos</IonLabel>
							</IonSegmentButton>
						</IonSegment>
					</SegmentContainer>
					<Grid
						media={listKey === 'photos' ? mediaImg : mediaVideo}
						listKey={listKey}
					/>
				</>
			) : (
				<>{offlineMediaPreview.length > 0 && <Grid media={offlineMediaPreview} />}</>
			)}
		</div>
	);
};

export default MediaGrid;
